import { useApiClient } from "@/src/hooks/useApiClient";

/** Cinq publications : ce qui tient sur un panneau sans le faire défiler. */
export const FEED_PREVIEW = 5;

/** `total` est un `count(*)` sur le statut : une ligne suffit à le connaître. */
const COUNT_ONLY = 1;

/**
 * Le pouls du fil : ce qui est en ligne, et ce qui attend une décision.
 *
 * ## Deux chiffres, deux natures
 *
 * `published` est un **volume** — le pendant du nombre de comptes ou
 * d'événements, à sa place dans la rangée de tuiles. `pending` est une **file à
 * relever**, et c'est lui qui rend le fil comparable aux signalements : une
 * publication retenue par le classifieur reste invisible **pour toujours** tant
 * qu'un humain ne tranche pas. Elle porte donc l'indice de la tuile, et remplit
 * le panneau.
 *
 * ⚠️ **Pas d'échéance de 24 h ici.** Celle du poste de garde vient de la
 * directive App Store 1.2, qui parle de contenu **signalé** ; une publication
 * retenue par la machine n'entre pas dans ce compte. L'âge s'affiche donc en
 * temps relatif ordinaire, pas en jauge.
 *
 * ⚠️ **Pas de `useQueryErrorToast` ici**, comme les trois autres hooks du
 * tableau de bord : l'écran n'en lève qu'un pour tous les domaines (cf.
 * `Dashboard`), sans quoi une seule panne en afficherait quatre au même instant.
 */
export function useFeedPulse() {
  const $api = useApiClient();

  /*
    Le serveur rend la file du plus ancien au plus récent : les cinq premiers
    sont donc les cinq qui attendent depuis le plus longtemps. On ne les retrie
    pas — c'est le sens même d'une file.
  */
  const queue = $api.useQuery("get", "/api/v1/moderation/post", {
    params: {
      query: { status: "pending_review", limit: FEED_PREVIEW, offset: 0 },
    },
  });

  const published = $api.useQuery("get", "/api/v1/moderation/post", {
    params: { query: { status: "approved", limit: COUNT_ONLY, offset: 0 } },
  });

  return {
    /** Les plus anciennes en attente : celles qu'il faut trancher d'abord. */
    posts: queue.data?.data?.posts ?? [],
    // ⚠️ `undefined` tant que le serveur n'a pas répondu, jamais `0` :
    // « aucune » et « on ne sait pas encore » ne se disent pas pareil.
    pending: queue.data?.data?.total,
    published: published.data?.data?.total,
    isLoading: queue.isLoading,
    isError: queue.isError,
  };
}
